export default __webpack_public_path__ + "static/media/leadership-lecture.e23fbe14.png";